import React from 'react';

import type { NavSubItem as NavSubItemType } from 'api/contentful/contentTypes.cloverdotcom';
import { GroupNavItem } from 'components/NavBar/NavItemsList/GroupNavItem/GroupNavItem';
import { SingleNavItem } from 'components/NavBar/NavItemsList/SingleNavItem/SingleNavItem';
import type { FlatEntry } from 'services/cms/flattenContentful';

import type { INavListLinkProps } from '../NavListLink/NavListLink';

interface INavSubItemProps
  extends React.HTMLAttributes<HTMLLIElement>,
    Pick<INavListLinkProps, 'closeDrawer'> {
  entry?: FlatEntry<NavSubItemType>;
  itemContentClassName?: string;
}

enum SubItemType {
  SINGLE_NAV_SUB_ITEM = 'singleNavSubItem',
  GROUP_NAV_SUB_ITEM = 'groupNavSubItem',
}

const getNavSubItemType = (entry: FlatEntry<NavSubItemType>): SubItemType | null => {
  const hasLink = entry.link;
  const hasSubItemLinks = entry.subItemLinks;
  const isSingleNavitem = hasLink && !hasSubItemLinks;
  const isGroupNavItem = !hasLink && hasSubItemLinks;

  if (isSingleNavitem) {
    return SubItemType.SINGLE_NAV_SUB_ITEM;
  }
  if (isGroupNavItem) {
    return SubItemType.GROUP_NAV_SUB_ITEM;
  }
  return null;
};

export const NavSubItem: React.FC<INavSubItemProps> = ({ entry, ...props }) => {
  if (!entry) return null;

  const navSubItemType = getNavSubItemType(entry);

  switch (navSubItemType) {
    case SubItemType.SINGLE_NAV_SUB_ITEM:
      return <SingleNavItem entry={entry} {...props} />;
    case SubItemType.GROUP_NAV_SUB_ITEM:
      return <GroupNavItem entry={entry} {...props} />;
    default:
      return null;
  }
};
